import { Box } from '@mui/material';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { PATHS } from '../../config/consts';
import LoginFlowsWrapper from '../_components/LoginFlowsWrapper';
import { AccountActivationForm } from './components/AccountActivationForm';
import messages from './components/AccountActivationForm/messages';

export function AccountActivationPage() {
  const navigate = useNavigate();
  const { formatMessage } = useIntl();

  return (
    <Box sx={{ backgroundColor: 'background.paper' }}>
      <LoginFlowsWrapper title={formatMessage(messages.ImsActivateAccountTitle)}>
        <AccountActivationForm
          onSuccess={() => {
            navigate(PATHS.LOGIN);
          }}
        />
      </LoginFlowsWrapper>
    </Box>
  );
}
